import { styled } from '@mui/material'
import type { AnchorPoint } from 'metalworks-domain'
import { ToolState } from 'metalworks-domain/src/__generated/application-types'
import { useObservableEagerState } from 'observable-hooks'
import { useCallback } from 'react'

import { SelectionHotspot as UiSelectionHotspot } from '@salsita-ai/platform-project-sdk/ui'

import { anchorPointsService } from '../systems/anchor-points-service'
import { configuratorInterface } from '../systems/configurator-interface'

const MeasurementHotspotActive = styled(
  UiSelectionHotspot,
  {}
)<{ powderCoating?: boolean }>(({ powderCoating }) => ({
  height: 20,
  width: 20,
  paddingInline: 0,
  borderColor: powderCoating ? '#000000' : '#000000',
  backgroundColor: powderCoating ? '#FFFFFF' : '#000000',
  borderWidth: 1,
}))

const MeasurementHotspotInactive = styled(
  UiSelectionHotspot,
  {}
)<{ powderCoating?: boolean }>(({ powderCoating }) => ({
  height: 10,
  width: 10,
  paddingInline: 0,
  borderColor: powderCoating ? '#000000' : '#000000',
  backgroundColor: powderCoating ? '#FFFFFF' : '#000000',
  borderWidth: 2,
}))

interface Props {
  id: AnchorPoint['id']
}

export const MeasurementToolHotspot = (props: Props) => {
  const { id } = props
  const { navigationSystem } = configuratorInterface.useDomain()
  const plate = configuratorInterface.useRootEntityState()

  const { measurementToolSourceId } = useObservableEagerState(anchorPointsService.state$)
  const toolState = useObservableEagerState(
    configuratorInterface.useStoreSelector$(emission => navigationSystem.getActiveToolState(emission.state), [])
  )

  const handleInactiveClick = useCallback(() => {
    anchorPointsService.setMeasurementToolSourceId(id)
  }, [id])

  const handleMeasurementToolEnter = useCallback(() => {
    if (!measurementToolSourceId) {
      return
    }

    anchorPointsService.setMeasurementToolDestinationId(id)
  }, [measurementToolSourceId, id])

  const handleMeasurementToolLeave = useCallback(() => {
    anchorPointsService.setMeasurementToolDestinationId(null)
  }, [])

  if (toolState !== ToolState.Measure) {
    return null
  }

  if (measurementToolSourceId === id) {
    return <MeasurementHotspotActive id={id} powderCoating={plate.powderCoating} />
  }

  return (
    <div onMouseEnter={handleMeasurementToolEnter} onMouseLeave={handleMeasurementToolLeave}>
      <MeasurementHotspotInactive id={id} powderCoating={plate.powderCoating} onClick={handleInactiveClick} />
    </div>
  )
}
